const env = require("app/services/env");

module.exports = function (...args) {
    if (!env.debug() && window && typeof window.gtag === 'function') {
        window.gtag(...args);
    }
};
